module.exports = __webpack_public_path__ + "static/avanade-7f89c85994d2e150f12e4e285ec02b87.png";